import EmptyActor from './EmptyActor';

export default EmptyActor;